import React from 'react';
import { motion } from 'framer-motion';
const education = [{
  degree: 'PhD, Electrochemistry',
  inst: 'Royal Military College of Science / Royal School of Mines, Imperial College London',
  dates: '1975–1978'
}, {
  degree: 'BSc (Hons), Metallurgy and Materials Science',
  inst: 'University of Nottingham',
  dates: '1972–1975'
}, {
  degree: 'Non-Executive Director Post-Graduate Diploma',
  inst: 'Financial Times',
  dates: '2018–2019'
}, {
  degree: 'MBA coursework',
  inst: 'Kent State University',
  dates: '1982–1984'
}];
const affiliations = ['Fellow, Institute of Materials, Minerals and Mining (FIMMM)', 'Fellow, The Energy Institute (FEI)', 'Member, Chatham House', 'Chartered Engineer (CEng)', 'Council Member, World Affairs Council of Houston'];
export function Education() {
  return <section id="education" className="py-24 bg-white" data-id="element-113">
      <div className="max-w-6xl mx-auto px-6 md:px-12" data-id="element-114">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16" data-id="element-115">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.6
        }} data-id="element-116">
            <h2 className="font-serif text-3xl text-navy mb-6" data-id="element-117">
              Education & Credentials
            </h2>
            <div className="w-12 h-px bg-gold mb-10" data-id="element-118"></div>

            <div className="space-y-8" data-id="element-119">
              {education.map((item, idx) => <div key={idx} className="border-b border-gray-100 pb-6 last:border-0" data-id="element-120">
                  <h3 className="font-medium text-navy text-lg mb-1" data-id="element-121">
                    {item.degree}
                  </h3>
                  <p className="text-gray-600 text-sm mb-2" data-id="element-122">{item.inst}</p>
                  <span className="text-xs font-medium text-gold uppercase tracking-wider" data-id="element-123">
                    {item.dates}
                  </span>
                </div>)}
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} data-id="element-124">
            <h2 className="font-serif text-3xl text-navy mb-6" data-id="element-125">
              Professional Affiliations
            </h2>
            <div className="w-12 h-px bg-gold mb-10" data-id="element-126"></div>

            <div className="grid grid-cols-1 gap-4" data-id="element-127">
              {affiliations.map((aff, idx) => <div key={idx} className="flex items-start space-x-4 p-4 bg-offwhite border border-gray-100" data-id="element-128">
                  <div className="w-1.5 h-1.5 rounded-full bg-gold mt-2 shrink-0" data-id="element-129"></div>
                  <p className="text-navy-light text-sm font-medium" data-id="element-130">{aff}</p>
                </div>)}
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}